<template>
    <div class="p-col-12">
        <page-header title="dataTable.letter.title" :actions="pageActions"/>
        <ancestryline-data-table :data-function="dataFunction" :columns="columns"/>
    </div>
</template>

<script>
    import AncestrylineDataTable from "@/components/table/AncestrylineDataTable";
    import FrontBusiness from "@/business/FrontBusiness";
    import PageHeader from "@/components/page/PageHeader";
    import ToastMessageBusiness from "@/business/ToastMessageBusiness";
    import DialogService from "@/business/ModalBusiness";
    import AncestrylineConfirmation from "@/components/dialog/AncestrylineConfirmation";
    import LetterBusiness from "@/business/LetterBusiness";

    export default {
        name: "LetterList",
        components: {PageHeader, AncestrylineDataTable},

        data() {
            return {
                dataFunction: LetterBusiness.pagination,
                columns: [
                    {field: "name", header: 'dataTable.letter.columns.name', sortable:true},
                    {field: "created", header: 'dataTable.letter.columns.created', sortable:true, type: 'date-time'},
                    {field: "actions", header: 'dataTable.actions', sortable:false, type: 'actions', style: 'width: 100px',
                        actions: [
                          {icon: 'pi pi-pencil', title: 'dataTable.type-service.columns.edit', function: this.editLetter},
                          {icon: 'pi pi-trash', title: 'dataTable.type-service.columns.delete', function: this.deleteLetter, refreshList: true},
                        ]
                    },
                ],
                pageActions: [
                    {icon: 'pi pi-tag', label: 'dataTable.letter.add', url: '/letter'},
                    {icon: 'pi pi-eye', label: 'audit.button-list', function: this.openModal, type: 'button'},
                ],
            }
        },

        methods: {

          editLetter(letter){
              FrontBusiness.redirect(`/letter/${letter.id}`);
          },

          async deleteLetter(letter, dataList){
            if(await DialogService.openConfirmationModal(AncestrylineConfirmation)){
              const response = await LetterBusiness.delete(letter.id).catch((e) => {
                if(e.letter_constraint){
                  ToastMessageBusiness.showError(e.letter_constraint)
                } else {
                  ToastMessageBusiness.showError(e.message)
                }
              });
              if(response){
                dataList = dataList.filter(c => c.id !== letter.id);
                ToastMessageBusiness.showSuccess();
              }
              return dataList;
            }
          },

          openModal(){
              //DialogService.openModal(Audit, {business: LetterBusiness});
          },

        }

    }
</script>

<style scoped>

</style>
